import { request } from "../";
export function createBranchPlan(data) {
  return request({ url: "branch-plans/", method: "POST", data});
}
export function getPlans() {
  return request({ url: "plans/" });
}
export function getBranchPlan() {
  return request({ url: "branch-plans/" });
}
export function getBranchInvoices() {
  return request({ url: "invoices/" });
}
export function getNotesPack() {
  return request({ url: "plans/notes-packs/" });
}
export function selectNotesPacks(pack, branchOwnerId = null) {
  if (branchOwnerId) {
    return request(
      { url: "plans/select-notes-packs/", method: "POST", data: pack },
      true,
      branchOwnerId
    );
  }
  return request({
    url: "plans/select-notes-packs/",
    method: "POST",
    data: pack,
  });
}
export function upgradeBranchPlan(new_plan_id) {
  const data = { new_plan_id };
  return request({ url: "branch-plans/upgrade/", method: "PUT", data });
}
export function adjustPlan() {
  return request({ url: "branch-plans/adjust/", method: "PUT" });
}
export function unSubscribe(data) {
  return request({ url: "feedbacks/cancel-plan/", method: "POST", data });
}
export function getIugu(id) {
  return request({ url: `invoices/${id}/iugu/` });
}



// WEBPACK FOOTER //
// ./src/api/plans/index.js